import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/auth`;

const saveMethode = async (methodData) => {
  const url = `${API_URL}/methode`;

  try {
    const response = await api.post(url, methodData);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la méthode de connexion :", error);
    handleHttpError(error, "Échec de l'enregistrement de la méthode de connexion.");
    throw error;
  }
};

const authenticateUser = async (loginRequest) => {
  const url = `${API_URL}/login`;

  try {
    const response = await api.post(url, loginRequest);
   
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la tentative de connexion :", error);
    handleHttpError(error, "Échec de la connexion. Veuillez vérifier vos identifiants.");
    throw error;
  }
};

const resendOtp = async (methodData) => {
  const url = `${API_URL}/resend-otp`;

  try {
    const response = await api.post(url, methodData);
    return response.data;
  } catch (error) {
    console.error("Erreur lors du renvoi du code OTP :", error);
    handleHttpError(error, "Impossible de renvoyer le code OTP. Veuillez réessayer.");
    throw error;
  }
};

export { saveMethode, authenticateUser, resendOtp };
